import React, { useState, forwardRef } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { Typography } from 'antd'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'

const { Text } = Typography

interface PasswordFieldProps extends React.ComponentProps<typeof Input> {
  label?: string
  required?: boolean
  error?: string
}

export const PasswordField = forwardRef<HTMLInputElement, PasswordFieldProps>(
  function PasswordField({ label, required, error, ...props }, ref) {
    const [visible, setVisible] = useState(false)
    const inputType = visible ? 'text' : 'password'

    return (
      <div>
        {label && (
          <label className="mb-1.5 block text-sm sm:text-base font-medium">
            {label} {required && <span className="text-red-500">*</span>}
          </label>
        )}
        <div className="relative">
          <Input {...props} ref={ref} type={inputType} size="large" />
          <Button
            variant="outline"
            size="icon"
            className="absolute right-2 top-1/2 -translate-y-1/2 border-0 !bg-transparent hover:!border-0 hover:!bg-transparent focus:!border-0 focus:!bg-transparent focus:outline-none"
            onClick={() => setVisible((prev) => !prev)}
            tabIndex={-1}
          >
            {visible ? (
              <EyeOff size={18} className="sm:w-5 sm:h-5" />
            ) : (
              <Eye size={18} className="sm:w-5 sm:h-5" />
            )}
          </Button>
        </div>
        {error && (
          <Text type="danger" className="mt-1 block text-xs sm:text-sm">
            {error}
          </Text>
        )}
      </div>
    )
  },
)
